/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CourseHistoryQueryVariables = {|
  eventId: string
|};
export type CourseHistoryQueryResponse = {|
  +whoAmI: ?{|
    +username: string
  |},
  +pgaTourGetCourseHistoryModelForEvent: ?{|
    +id: string
  |},
  +pgaTourEvent: ?{|
    +id: string,
    +tournament: {|
      +officialName: string
    |},
  |},
  +pgaEventCoursesForEvent: ?$ReadOnlyArray<?{|
    +id: string,
    +course: {|
      +name: string
    |},
  |}>,
|};
export type CourseHistoryQuery = {|
  variables: CourseHistoryQueryVariables,
  response: CourseHistoryQueryResponse,
|};
*/


/*
query CourseHistoryQuery(
  $eventId: ID!
) {
  whoAmI {
    username
    id
  }
  pgaTourGetCourseHistoryModelForEvent(eventId: $eventId) {
    id
  }
  pgaTourEvent(eventId: $eventId) {
    id
    tournament {
      officialName
      id
    }
  }
  pgaEventCoursesForEvent(eventId: $eventId) {
    id
    course {
      name
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "eventId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "eventId",
    "variableName": "eventId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": (v2/*: any*/),
  "concreteType": "PGATourModelType",
  "kind": "LinkedField",
  "name": "pgaTourGetCourseHistoryModelForEvent",
  "plural": false,
  "selections": [
    (v3/*: any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "officialName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CourseHistoryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      (v4/*: any*/),
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "PGATourEventType",
        "kind": "LinkedField",
        "name": "pgaTourEvent",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourTournamentType",
            "kind": "LinkedField",
            "name": "tournament",
            "plural": false,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "PGATourEventCourseType",
        "kind": "LinkedField",
        "name": "pgaEventCoursesForEvent",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourCourseType",
            "kind": "LinkedField",
            "name": "course",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CourseHistoryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      (v4/*: any*/),
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "PGATourEventType",
        "kind": "LinkedField",
        "name": "pgaTourEvent",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourTournamentType",
            "kind": "LinkedField",
            "name": "tournament",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "PGATourEventCourseType",
        "kind": "LinkedField",
        "name": "pgaEventCoursesForEvent",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourCourseType",
            "kind": "LinkedField",
            "name": "course",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fe9bdca77d4983eedebc602d441d86e5",
    "id": null,
    "metadata": {},
    "name": "CourseHistoryQuery",
    "operationKind": "query",
    "text": "query CourseHistoryQuery(\n  $eventId: ID!\n) {\n  whoAmI {\n    username\n    id\n  }\n  pgaTourGetCourseHistoryModelForEvent(eventId: $eventId) {\n    id\n  }\n  pgaTourEvent(eventId: $eventId) {\n    id\n    tournament {\n      officialName\n      id\n    }\n  }\n  pgaEventCoursesForEvent(eventId: $eventId) {\n    id\n    course {\n      name\n      id\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0016a4ce32ae16c3da343b648ff4e7e6';

module.exports = node;
